<template>
  <div class="training-section-gallery-item">
    <div
      v-if="image"
      class="gallery-item-image"
    >
      <BgMedia :media="getBackground()" />
    </div>
    <div
      v-if="title || description"
      class="gallery-item-content"
    >
      <h3
        v-if="title"
        class="gallery-item-title"
        v-html="title"
      ></h3>
      <div
        v-if="description"
        class="gallery-item-description"
        v-html="markdownToHTML(description || '')"
      ></div>
    </div>
  </div>
</template>

<script>
import BgMedia from '@/components/BgMedia.vue';

// Markdown
const md = require('markdown-it')({
  html: true,
  linkify: true,
  typographer: true,
});

export default {
  name: 'TrainingSectionGalleryItem',
  components: {
    BgMedia,
  },
  props: {
    image: {
      type: Object,
      default: null,
    },
    imageMobile: {
      type: Object,
      default: null,
    },
    title: {
      type: String,
      default: '',
    },
    description: {
      type: String,
      default: '',
    },
  },
  methods: {
    markdownToHTML(content) {
      return md.render(content);
    },
    getBackground() {
      return {
        background: this.image,
        backgroundMobile: this.imageMobile,
      };
    },
  },
};
</script>

<style lang="scss" scoped>
.training-section-gallery-item {
  display: flex;
  flex-direction: column;
  width: 100%;

  .gallery-item-image {
    position: relative;
    display: block;
    overflow: hidden;
    width: 100%;

    @include wRule(
      height,
      (
        xl: 400,
        lg: 360,
        md: 320,
        sm: auto,
      )
    );

    @include screen("sm", max) {
      position: relative;
      padding-bottom: 0;

      &::before {
        display: none;
      }
    }

    ::v-deep(.bg-media) {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;

      @include screen("sm", max) {
        position: relative;
        height: auto;
      }

      img {
        object-fit: contain !important;

        @include screen("sm", max) {
          position: relative !important;
          width: 100% !important;
          height: auto !important;
        }
      }

      picture {
        @include screen("sm", max) {
          position: relative !important;
          height: auto !important;
        }
      }
    }
  }

  .gallery-item-content {
    display: flex;
    flex-direction: column;
    padding: 20px 0;

    @include screen("sm", max) {
      padding: 30px 0;
    }
  }

  .gallery-item-title {
    font-weight: 700;
    line-height: 1.2;

    @include wRule(
      font-size,
      (
        xl: 24,
        lg: 20,
        md: 18,
        sm: 32,
      )
    );

    &:not(:last-child) {
      @include wRule(
        margin-bottom,
        (
          xl: 12,
          lg: 10,
          md: 10,
          sm: 15,
        )
      );
    }
  }

  .gallery-item-description {
    font-weight: 400;
    line-height: 1.6;
    color: #999;

    @include wRule(
      font-size,
      (
        xl: 18,
        lg: 16,
        md: 14,
        sm: 28,
      )
    );

    ::v-deep(p) {
      margin: 0;

      &:not(:last-child) {
        @include wRule(
          margin-bottom,
          (
            xl: 12,
            lg: 10,
            md: 10,
            sm: 15,
          )
        );
      }
    }
  }
}
</style>
